import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { HiddenRecordType } from '../../../types';
import { DEFAULT_ADVANCE_BUTTON_STYLE, DEFAULT_CANCEL_BUTTON_STYLE } from '../../../utils/styleHelpers';

export interface HideConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  type: 'Hide' | 'Unhide';
  recordType: HiddenRecordType;
}

const RECORD_LABELS: Record<HiddenRecordType, { noun: string; title: string }> = {
  Inventory: { noun: 'inventory record', title: 'Inventory Record' },
  Project: { noun: 'project', title: 'Project' },
  Quote: { noun: 'quote', title: 'Quote' }
};

const BODY_TEXT: Record<HideConfirmationDialogProps['type'], string> = {
  Hide: 'You can "unhide" the record later via Account Detail in the Admin section.',
  Unhide: 'Once unhidden, the record is visible again to anyone with access to the account.'
};

export const HideConfirmationDialog = ({ open, onClose, onConfirm, type, recordType }: HideConfirmationDialogProps) => {
  const { noun, title } = RECORD_LABELS[recordType];
  return (
    <Dialog
      open={open}
      onClose={onClose}>
      <DialogTitle>{`${type} ${title}`}</DialogTitle>
      <DialogContent>
        <DialogContentText>{`Are you sure you want to ${type.toLowerCase()} this ${noun}?`}</DialogContentText>
        <DialogContentText sx={{ mt: 1 }}>{BODY_TEXT[type]}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <button
          onClick={onClose}
          className={DEFAULT_CANCEL_BUTTON_STYLE}>
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className={DEFAULT_ADVANCE_BUTTON_STYLE}>
          {type}
        </button>
      </DialogActions>
    </Dialog>
  );
};
